import { render } from "./AwardsList.vue?vue&type=template&id=3bd44dcf"
import script from "./AwardsList.vue?vue&type=script&lang=js"
export * from "./AwardsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__